// extracted by mini-css-extract-plugin
export default {"DocumentActionButton":"uWGQaky3neNrdOah3pmt","DocumentActionsSupText":"R7FbUMLG4U2lGEqKCvfl"};